import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol viewBox=\"0 0 500 501\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\"><title>icon-plus</title><path d=\"M250.462 450.923C140.854 450.923 52 362.07 52 252.462 52 142.854 140.854 54 250.462 54c109.607 0 198.461 88.854 198.461 198.462 0 109.607-88.854 198.461-198.461 198.461zM260 241v-82a9 9 0 1 0-18 0v82h-82a9 9 0 1 0 0 18h82v82a9 9 0 1 0 18 0v-82h82a9 9 0 1 0 0-18h-82z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol